/**
 * v2 auth-layer constants. v2 must not import from src/contstant/*.
 * Mirror the values that v2 needs from there as our own source of truth.
 */

/** Program identifier the orbit service uses to scope this app's data. */
export const APP_PROGRAM_ID = 'SAT';

/**
 * LocalStorage keys owned by v2 auth.
 *
 * MIDWAY_AUTH_USERNAME shares the same key as the legacy app on purpose so the
 * two apps don't fight over alias storage during the transition. Once legacy
 * is gone (Phase 5), this key can be renamed.
 */
export const AuthStorageKeys = {
  MidwayAuthUsername: 'MIDWAY_AUTH_USERNAME',
} as const;

/** Midway endpoint URLs and request shape. */
export const MIDWAY_AUTH_BASE_URL = 'https://midway-auth.amazon.com/SSO';
export const MIDWAY_AUTH_HOSTNAME = 'midway-auth.amazon.com';
export const MIDWAY_REDIRECT_PATH = '/redirect';
export const MIDWAY_SENTRY_HANDLER_VERSION = 'MidwayNginxModule-1.3-1';

export const MIDWAY_RESPONSE_TYPE_ID_TOKEN = 'id_token';
export const MIDWAY_SCOPE_OPENID = 'openid';
export const MIDWAY_DEFAULT_PORT = '443';
export const MIDWAY_HTTPS_PROTOCOL = 'https:';

/** URL query parameter the Midway redirect appends after auth. */
export const MIDWAY_ID_TOKEN_PARAM = 'id_token';
export const MIDWAY_REDIRECT_URI_PARAM = 'redirect_uri';

/**
 * Delay before stripping the Midway token from the URL.
 * The legacy implementation uses 2s to give downstream code time to read it.
 */
export const MIDWAY_URL_CLEANUP_DELAY_MS = 2000;

/** Number of nonce bytes to generate per Midway request. */
export const MIDWAY_NONCE_WORD_COUNT = 5;

/** HTTP status that signals the user must reauthenticate. */
export const HTTP_STATUS_UNAUTHORIZED = 401;
